import styles from "./WidgetFooter.module.scss";
import ChevronRightOutlinedIcon from "@material-ui/icons/ChevronRightOutlined";

const WidgetFooter = ({ ctaClick }) => (
  <div className={styles.Container} onClick={ctaClick}>
    <div className={styles.LeftLabel}>
      Start your <span className={styles.HighLight}>Crypto</span> journey!
    </div>
    <div className={styles.CTA}>
      <div className={styles.Left}>
        With just <b>₹100</b>
      </div>
      <div className={styles.Right}>
        Invest Now{" "}
        <ChevronRightOutlinedIcon className={styles.Icon} fontSize="small" />
      </div>
    </div>
  </div>
);

export default WidgetFooter;
